import React from 'react';
import { FaArrowDown } from 'react-icons/fa6';

export const ButtonLinkWrapper = ({ children }) => {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>{children}</div>
  );
};

const styles = {
  marginLeft: 0,
  display: 'inline-flex',
  alignItems: 'center',
  gap: '5px',
  fontSize: '18px',
  padding: '0.7rem 1rem',
  marginTop: '10px',
  borderRadius: '25px',
  border: '2px solid #dc6499',
  boxShadow: 'none',
};

export const ButtonLink = ({ slug, externalLink, children }) => {
  if (externalLink) {
    return (
      <a
        className="w-button button"
        href={externalLink}
        target="_blank"
        rel="noopener noreferrer"
        style={styles}
      >
        {children}
      </a>
    );
  }

  if (slug.startsWith('#')) {
    return (
      <a className="w-button button" href={slug} style={styles}>
        <FaArrowDown />
        {children}
      </a>
    );
  }

  return (
    <a className="w-button button" href={`/${slug}`} style={styles}>
      {children}
    </a>
  );
};
